import React from "react";
import Icons from "../../Constants/Icons";
import Colors from "../../Constants/Colors";
import { useNavigate } from "react-router-dom";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";
import moment from "moment";

const UpcomingEventsScreen = ({
  data,
  handelEnabled,
  adminEventEdit,
  onClickFeaturedStatus,
  masterEvent = false,
  copy = false,
  refresh = false,
  cancel = false,
}) => {
  const navigate = useNavigate();
  const onClickEventDetails = (item) => {
    navigate("/EventDetails", {
      state: {
        isMasterEvent: masterEvent,
        eventId: item.eventId,
      },
    });
  };
  const handleEditClick = (item) => {
    navigate("/EventUpdate", {
      state: {
        eventId: item.eventId,
        eventTypeId: item.eventTypeId,
        adminEventEdit: adminEventEdit,
      },
    });
  };
  const handleRepeatEventClick = (item) => {
    navigate("/EventRepeat", {
      state: {
        eventId: item.eventId,
        adminEventRepeat: true,
      },
    });
  };
  const handleSubMasterEvent = (item) => {
    navigate(`/SubMasterEvents/${item.eventId}`, {
      state: {
        eventId: item.eventId,
      },
    });
  };

  const handleCopyId = (id) => {
    console.log("test", id);
    navigator.clipboard.writeText(id);
    toast.success("ID copied!", id);
  };
  return (
    <div>
      <div style={{ maxHeight: "500px" }} className="scrollable-container">
        {data?.map((item, index) => (
          <div key={index}>
            <div className="achievement-stretch-row">
              <div className="lastWeekEndDivGreyColor w-8">
                <img
                  src={item.eventImages ?? Icons.ic_AY_logo}
                  className="subcategory-input"
                  style={{
                    cursor: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div
                className="fontSize16WithoutFlex w-10 "
                style={{ display: "flex", gap: "10px" }}
              >
                {item.eventTypeName}
                {copy && (
                  <FiCopy
                    className="copy-icon"
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    title="Copy Event ID"
                    onClick={() => handleCopyId(item.eventId)}
                  />
                )}
              </div>
              <div className="w-22" style={{ paddingLeft: 0 }}>
                <div
                  style={{ paddingRight: 18, wordBreak: "break-word" }}
                  className="fontSize16WithoutFlex"
                >
                  {item.eventName}
                </div>
              </div>
              <div className="w-30" style={{ paddingLeft: 0 }}>
                <div className="achievement-title">
                  <img
                    className="icon_style_list"
                    alt=""
                    src={Icons.ic_calendar}
                  />
                  <div style={{}} className="itemTextDisplay">
                    {moment(
                      `${item.eventStartDate} ${item.eventStartTime}`,
                      "DD/MM/YYYY HH:mm:ss",
                    ).format("dddd, DD MMM YYYY, hh:mm A")}
                  </div>
                </div>
                <div style={{}} className="achievement-title">
                  <img
                    className="icon_style_list"
                    alt=""
                    src={Icons.ic_location}
                  />
                  <div style={{ paddingRight: 18 }} className="itemTextDisplay">
                    {item.venueAddress}
                  </div>
                </div>
              </div>
              <div style={{ gap: "12px", display: "flex" }} className="w-10">
                {item.isMasterTicket && item.doRepeat && (
                  <img
                    src={Icons.event_sub_ticket}
                    onClick={() => handleSubMasterEvent(item)}
                    className="edit-button pointer"
                  />
                )}
                <img
                  src={Icons.event_eye}
                  onClick={() => onClickEventDetails(item)}
                  className="edit-button pointer"
                />
                <img
                  src={Icons.edit}
                  onClick={() => handleEditClick(item)}
                  className="edit-button pointer"
                />
                {refresh && (
                  <img
                    src={Icons.ic_refresh}
                    onClick={() => handleRepeatEventClick(item)}
                    className="edit-button pointer"
                  />
                )}
              </div>
              <div style={{}} className="fontSize16WithoutFlex w-10">
                <div className="user_Status pointer">
                  <button
                    onClick={() => handelEnabled(item, index)}
                    className="button"
                    style={{
                      cursor: "pointer",
                      backgroundColor: item.isEnabled
                        ? Colors.mainGreen01
                        : Colors.mainRed01,
                      color: item.isEnabled ? Colors.darkGreen : Colors.darkRed,
                    }}
                  >
                    {item.isEnabled ? "Activate" : "Deactivate"}
                  </button>
                </div>
              </div>
              {cancel && (
                <div style={{}} className="fontSize16WithoutFlex w-10">
                  <div className="user_Status pointer">
                    <button
                      className={`button ${
                        item.isCancel ? "btn-red-no" : "btn-green-yes"
                      }`}
                    >
                      {item.isCancel ? "Canceled" : "Active"}
                    </button>
                  </div>
                </div>
              )}

              <div className="fontSize16WithoutFlex w-10">
                <div className="user_Status pointer">
                  <button
                    onClick={() => onClickFeaturedStatus(item, index)}
                    className="button"
                    style={{
                      cursor: "pointer",
                      backgroundColor: item.isFeatured
                        ? Colors.mainGreen01
                        : Colors.mainRed01,
                      color: item.isFeatured
                        ? Colors.darkGreen
                        : Colors.darkRed,
                    }}
                  >
                    {item.isFeatured ? "Activate" : "Deactivate"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default UpcomingEventsScreen;
